module.exports = __webpack_public_path__ + "static/media/paletteFromPalette.3b88393c.mov";